/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import Select from 'react-select';
import { customStyle } from 'helper';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import Loading from 'modules/common/components/Loading';
import moment from 'moment';
import PropTypes from 'prop-types';
import withDashboard from '../../../../common/hoc/withDashboard';

import * as actions from '../action';
import * as c from '../constant';
import CivilRegistryChartComponent from '../components/CivilRegistryChartComponent';

const colors = ['#5272AA', '#8EEED7'];

const filter = {
  transaction_type: 'ALL',
};

const renderLegends = (dt) =>
dt.map((x) => {
  return (
    <div key={x.name} className="legend-item">
      <div
        style={{
          background: `${x.color}`,
          width: 20,
          height: 20,
          marginRight: 20,
        }}
      />
      <div className="legend-text">{x.name}</div>
    </div>
  );
});

function CivilRegistryDashboardContainer({
  // createDynamicAreaChart,
  // transactionList,
  graphStats,
  getGraphStats,
}) {
  const permissions = getJson('permissions');
  const [filterData, setFilterData] = useState(filter);
  const [isLoading, setIsLoading] = useState(true);

  const handleOnSubmit = (data) => {
    const args = {
      ...data,
      permit_type: 'Local Civil Registry',
    }
    getGraphStats(args);
  };

  // const handleOnSubmit = ({ type, from, to }) => {
  //   // eslint-disable-next-line no-console
  //   getGraphStats({
  //     period: type,
  //     date_from: from,
  //     date_to: to,
  //     permit_type: 'Local Civil Registry',
  //   });
  // };

  const handleChangeSelect = (e) => {
    setFilterData({
      ...filterData,
      transaction_type: e ? e.value : '',
    });
  };

  const filterCivilRegistryCertificate = () => {
    const legends = c.LEGENDS || []
   
    return [...legends?.filter(item => {
      return [
        Acl(permissions, ['VIEW BIRTH CERTIFICATE']) ? "BIRTH CERTIFICATE" : "",
        Acl(permissions, ['VIEW DEATH CERTIFICATE']) ? "DEATH CERTIFICATE" : "",
        Acl(permissions, ['VIEW MARRIAGE CERTIFICATE']) ? "MARRIAGE CERTIFICATE" : "",
      ].indexOf(item.name) !== -1
    }),
  ]
  }

  const formatKey = [
    {
      key: 'INDIVIDUAL',
      color: `${colors[0]}`,
    },
    {
      key: 'CORPORATION',
      color: `${colors[1]}`,
    },
  ];

  useEffect(() => {
    getGraphStats();
    setIsLoading(false);
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className="dashboard-card">
      <div className="row mb-3">
        <div className="col-12">
          <div className="main-text">Statistics</div>
        </div>
        <div className="col-12">
          <SelectDateFilter onSubmit={handleOnSubmit} />
        </div>
        <div className="col-12">
          <CivilRegistryChartComponent
            chartData={graphStats}
          />
        </div>
        <div className="legends-wrapper area px-3 w-100">
          <div
            className="render-chart-legends"
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            {renderLegends(filterCivilRegistryCertificate())}
          </div>
        </div>
      </div>
    </div>
  );
}

CivilRegistryDashboardContainer.propTypes = {
  // createDynamicAreaChart: PropTypes.instanceOf(Function).isRequired,
  // transactionList: PropTypes.instanceOf(Array).isRequired,
  graphStats: PropTypes.instanceOf(Array).isRequired,
  getGraphStats: PropTypes.instanceOf(Function).isRequired,
};

// const formatGraphData = (data) => {
//   const labels = [];
//   const values = [];

//   data.forEach((item, i) => {
//     const entries = Object.entries(item).filter(
//       (a) => ['name', 'included', 'RPT', 'BPLS'].indexOf(a[0]) < 0
//     );

//     if (i === 0) {
//       entries.forEach((entry, x) => {
//         labels[x] = {
//           key: entry[0],
//           color: colors[x],
//         };
//       });
//     }

//     values[i] = rename(
//       rename(
//         rename(item, 'OHP', 'Occupational / Health Permits'),
//         'CDL',
//         'Community Tax CertificateCTC / CEDULA'
//       ),
//       'PSA',
//       'Civil Registry Office'
//     );
//   });

//   return {
//     labels,
//     values,
//   };
// };

const mapStateToProps = ({ api }) => ({
  graphStats: _.get(api, `${c.GET_GRAPH_STATS}.list`) || [],
  transactionList: [
    {
      INDIVIDUAL: 812,
      CORPORATION: 340,
      name: 'JAN',
    },
    {
      INDIVIDUAL: 512,
      CORPORATION: 121,
      name: 'FEB',
    },
  ],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(CivilRegistryDashboardContainer);
